import { render, staticRenderFns } from "./AvisoPrivacidad.vue?vue&type=template&id=f0ef6a68&scoped=true"
import script from "./AvisoPrivacidad.vue?vue&type=script&lang=js"
export * from "./AvisoPrivacidad.vue?vue&type=script&lang=js"
import style0 from "./AvisoPrivacidad.vue?vue&type=style&index=0&id=f0ef6a68&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0ef6a68",
  null
  
)

export default component.exports